import usePageLang from "@src/hooks/usePageLang";
import { graphql, useStaticQuery } from "gatsby";

interface UseLanguagesData {
  currentLang: string;
  languages: Array<{
    id: string;
    value: string;
    label: string;
    rightToLeft: boolean;
  }>;
}

const useLanguages = (): UseLanguagesData => {
  const currentLang = usePageLang();
  const { allLanguage } = useStaticQuery<Queries.AllLanguageQuery>(graphql`
    query AllLanguage {
      allLanguage {
        edges {
          node {
            id
            id_lang
            lang
            iso_code
            name
            default_lang
            id_lang_lang
            rightToLeft
          }
        }
      }
    }
  `);

  return {
    currentLang: currentLang || "",
    languages: allLanguage.edges
      .filter((edge) => edge.node.lang === currentLang)
      .map((edge) => ({
        id: edge.node.id,
        value: edge.node.iso_code?.toLocaleLowerCase() || "",
        label: edge.node.name || "",
        rightToLeft: edge.node.rightToLeft || false,
      })),
  };
};

export default useLanguages;
